import { useContext, useImperativeHandle, useState, useEffect, useRef } from "react";
import patternClose from '../../../static/img/pattern_close2.png'
import patternScale from '../../../static/img/pattern_scale2.png'
import patternRote from '../../../static/img/rote.png'
import textEdit from '../../../static/img/txt_edit.png'
import TContext from '../context'

const cutpartBoxStyle: React.CSSProperties = {
    background: '#ffffff',
    overflow: 'hidden',
}

const canvas2D: any = {
    display: 'block',
    width: '100%',
    margin: '0 auto',
    touchAction: 'none',
    boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
}

export interface Props {
    controPosition?: any
    action?: any,
    // canvasShapeConfigs?: Record<string, any>,
}

export interface Action {
    setShow?: (s: boolean) => void;
    setBottom?: (s: number) => void;
    setUseSafeHeight?: (s: boolean) => void;
}

const paddingHeight = 10
export const Height = paddingHeight + paddingHeight

const Index = (props: Props) => {
    const [show, setInnerShow] = useState<boolean>(false)
    const [bottom, setBottom] = useState<number>(0)
    const [useSafeHeight, setUseSafeHeight] = useState<boolean>(true)
    const [canvasSize, setCanvasSize] = useState({ width: 0, height: 0 })
    const containerRef = useRef<HTMLDivElement | null>(null);
    const setContainerRef = (el: HTMLDivElement | null) => {
        containerRef.current = el; // 把DOM元素存入 ref.current
    };
    const tc = useContext(TContext)
   
    // 使用 ResizeObserver 监听容器尺寸变化
    useEffect(() => {
        if (!containerRef) return;

        const updateCanvasSize = () => {
            const containerWidth = containerRef?.current?.clientWidth || 0;

            if (containerWidth > 0) {
                // 根据容器宽度计算画布尺寸，保持宽高一致
                let calculatedSize = containerWidth;

                // 限制最小和最大尺寸
                if (containerWidth < 400) {
                    calculatedSize = 400; // 最小400px
                } else if (containerWidth > 600) {
                    calculatedSize = 600; // 最大600px
                } else {
                    calculatedSize = containerWidth - 20; // 留出边距
                }

                setCanvasSize({ width: calculatedSize, height: calculatedSize });
                // console.log(calculatedSize, "calculatedSize")
            }
        };

        // 立即执行一次
        updateCanvasSize();

        // 使用 ResizeObserver 监听尺寸变化
        const resizeObserver = new ResizeObserver(updateCanvasSize);
        resizeObserver.observe(containerRef.current!);

        return () => {
            resizeObserver.disconnect();
        };
    }, [containerRef]);

    // 更新 fabric 客户端尺寸
    useEffect(() => {
        if (tc.fabricClient && canvasSize.width > 0) {
            tc.fabricClient.setWidth(canvasSize.width);

            // 延迟重新渲染，确保尺寸更新完成
            setTimeout(() => {
                if (tc.curCanvasClient) {
                    const fabricCanvas = tc.curCanvasClient.getFabricCanvas();
                    // 添加安全检查
                    if (fabricCanvas && fabricCanvas.getContext()) {
                        try {
                            fabricCanvas.calcOffset();
                            fabricCanvas.renderAll();

                            // 如果有活动对象，重新激活以更新控制点
                            const activeObject = fabricCanvas.getActiveObject();
                            if (activeObject) {
                                fabricCanvas.discardActiveObject();
                                setTimeout(() => {
                                    // 再次检查状态
                                    if (fabricCanvas && !fabricCanvas.isDestroyed) {
                                        fabricCanvas.setActiveObject(activeObject);
                                        fabricCanvas.requestRenderAll();
                                    }
                                }, 100);
                            }
                        } catch (error) {
                            console.warn('Canvas 渲染过程中出现预期内的错误:', error);
                            // 忽略这个错误，因为后续的正确渲染会覆盖
                        }
                    }
                }
            }, 150);
        }
    }, [canvasSize, tc.fabricClient, tc.curCanvasClient]);

    useImperativeHandle(props.action, () => ({
        setShow,
        setBottom,
        setUseSafeHeight
    }));

    const setShow = (isShow: boolean) => {
        setInnerShow(isShow)
    }

    const handleDelete = () => {
        if (tc?.onDelCutpartObject) {
            tc.onDelCutpartObject();
        }
    }

    const handleEditText = () => {
        if (tc?.onEditText) {
            tc.onEditText();
        }
    }
    // 动态计算控制点大小
    const getControlIconSize = () => {
        const baseSize = 19;
        if (canvasSize.width < 450) {
            return Math.max(baseSize * 0.8, 15);
        }
        return baseSize;
    };

    const controlIconSize = getControlIconSize();
    return (
        <div style={cutpartBoxStyle}>
            <div style={{ height: paddingHeight }}></div>
            <div
                ref={setContainerRef}
                style={{
                    width: '100%',
                    height: 'auto',
                    position: 'relative',
                    margin: '0 auto',
                    overflow: "visible",
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '10px 0'
                }}
            >
                {canvasSize.width > 0 && (
                    <div style={{
                        width: canvasSize.width,
                        height: canvasSize.height,
                        position: 'relative',
                        border: '1px solid #e8e8e8',
                        borderRadius: '4px',
                        background: '#fafafa',
                        overflow: 'hidden'
                    }}
                    >
                        <div>
                            {
                                tc?.detailData?.model_materials?.cutparts?.map((v: any) => (
                                    <div key={v.code} style={{
                                        display: tc.curCutpartCode === v.code ? 'block' : 'none',
                                        width: '100%',
                                        height: '100%',
                                        position: 'relative'
                                    }}>
                                        <canvas
                                            id={v.code}
                                            style={{
                                                ...canvas2D,
                                                width: '100%',
                                                height: '100%',
                                                display: 'block'
                                            }}
                                        ></canvas>
                                        <div style={{
                                            position: "absolute",
                                            width: '100%',
                                            height: '100%',
                                            left: 0,
                                            top: 0,
                                            pointerEvents: "none",
                                            background: `url(${v.img})`,
                                            backgroundSize: `contain`,
                                            backgroundRepeat: "no-repeat",
                                            backgroundPosition: "center center"
                                        }} />
                                    </div>
                                ))
                            }
                        </div>

                        {/* 控制点 */}
                        {tc.controPosition && (
                            <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                pointerEvents: 'none',
                                zIndex: 10
                            }}>
                                {/* 关闭按钮 */}
                                <div
                                    style={{
                                        position: 'absolute',
                                        ...tc.controPosition?.tl_position,
                                        pointerEvents: 'auto',
                                        cursor: 'pointer',
                                        zIndex: 11,
                                        transform: 'translate(-50%, -50%)' // 居中控制点
                                    }}
                                    onClick={handleDelete}
                                >
                                    <img
                                        src={patternClose}
                                        style={{
                                            height: controlIconSize,
                                            width: controlIconSize,
                                            display: 'block'
                                        }}
                                        alt={t('删除')}
                                    />
                                </div>

                                {/* 缩放控制点 */}
                                <div
                                    style={{
                                        position: 'absolute',
                                        ...tc.controPosition?.br_position,
                                        cursor: 'nwse-resize',
                                        zIndex: 11,
                                    }}
                                >
                                    <img
                                        src={patternScale}
                                        style={{
                                            height: controlIconSize,
                                            width: controlIconSize,
                                            display: 'block'
                                        }}
                                        alt={t('缩放')}
                                    />
                                </div>

                                {/* 旋转控制点 */}
                                <div
                                    style={{
                                        position: 'absolute',
                                        ...tc.controPosition?.tr_position,
                                        cursor: 'pointer',
                                        zIndex: 11,
                                    }}
                                >
                                    <img
                                        src={patternRote}
                                        style={{
                                            height: controlIconSize,
                                            width: controlIconSize,
                                            display: 'block'
                                        }}
                                        alt={t('旋转')}
                                    />
                                </div>

                                {/* 文本编辑按钮 */}
                                {tc?.curActivityObject?.type === "text" && (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            ...tc.controPosition?.bl_position,
                                            cursor: 'pointer',
                                            zIndex: 11,
                                            pointerEvents: 'auto',
                                            transform: 'translate(-50%, -50%)' // 居中控制点
                                        }}
                                        onClick={handleEditText}
                                    >
                                        <img
                                            src={textEdit}
                                            style={{
                                                height: controlIconSize,
                                                width: controlIconSize,
                                                display: 'block'
                                            }}
                                            alt={t('编辑文本')}
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default Index
